import useAuth from "@/components/auth/useAuth"
import JSONNodeDisplay from "@/components/common/shared/JSONViewer/JSONNodeDisplay"
import { Button, Grid } from "@material-ui/core"
import { ArrowDropDown, ArrowRight } from "@material-ui/icons"
import React, { useState } from "react"

const DebugDisplay = props => {
  const { user } = useAuth()
  const [open, setOpen] = useState(false)
  return user?.superuser ? (
    <>
      <Grid container>
        <Grid item>
          <Button
            style={{ background: "brown", color: "white" }}
            onClick={() => setOpen(e => !e)}
            endIcon={open ? <ArrowDropDown /> : <ArrowRight />}
          >
            Debug {props?.title}
          </Button>
        </Grid>
        {open && (
          <>
            <Grid item>
              <Button
                onClick={() =>
                  navigator.clipboard.writeText(JSON.stringify(props, null, 2))
                }
              >
                Copy
              </Button>
            </Grid>
            <Grid item xs={12}>
              {Object.keys(props).map(
                (prop, index) =>
                  prop !== "title" && (
                    <JSONNodeDisplay
                      data={props[prop]}
                      key={"debug_map_" + index + "_" + prop}
                    />
                  )
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  ) : (
    <></>
  )
}

export default DebugDisplay
